// Mui
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";

// Mui Icon
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ClearIcon from "@mui/icons-material/Clear";

export function EscapeRegExp(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

export function SearchingBar(props) {
  return (
    <TextField
      sx={{ fontWeight: "bold" }}
      className="searchTextField"
      variant="standard"
      value={props.value}
      onChange={props.onChange}
      placeholder={props.placeholder ? props.placeholder : "搜索"}
      slotProps={{
        input: {
          startAdornment: props.startAdornment !== false && (
            <SearchOutlinedIcon fontSize="small" />
          ),
          endAdornment: (
            <IconButton
              title="Clear"
              aria-label="Clear"
              size="small"
              style={{ visibility: props.value ? "visible" : "hidden" }}
              onClick={props.clearSearch}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        },
      }}
      InputProps={{}}
    />
  );
}
